import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Duermes profundo desde la primera semana', 'Tu energía regresa de forma natural', 'La grasa abdominal empieza a reducirse', 'Tu mente recupera claridad y calma'];
export const SolutionSection: React.FC = () => {
  return <section className="py-20 lg:py-28 bg-white overflow-hidden" data-id="element-141">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-143">
          <motion.div className="mb-16 lg:mb-0 order-2 lg:order-1 relative" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-144">
            {/* Decorative accent block behind image */}
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-brand-mint/40 rounded-3xl hidden lg:block" aria-hidden="true" data-id="element-145" />
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-brand-lightmint rounded-2xl hidden lg:block" aria-hidden="true" data-id="element-146" />

            <div className="relative w-full max-w-md mx-auto aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl" data-id="element-147">
              <img src="https://cdn.magicpatterns.com/uploads/gujv6zadQjdqGuAM3QYrya/ChatGPT_Image_17_may_2026,_02_14_59_p.m..png" alt="Mujer disfrutando una taza de té herbal en una cocina luminosa, relajada y sonriente" className="w-full h-full object-cover" data-id="element-148" />
            </div>
          </motion.div>

          <motion.div className="order-1 lg:order-2" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-149">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-brand-charcoal leading-tight mb-6" data-id="element-150">
              La guía que nadie te dio para resetear tu hormona del estrés
            </h2>

            <p className="text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-151">
              <strong className="text-brand-charcoal" data-id="element-152">
                Resetea tu Cortisol en 21 Días
              </strong>{' '}
              es el método paso a paso basado en ciencia para regular el
              cortisol de forma natural, sin medicamentos, sin dietas extremas y
              sin sacrificios imposibles.
            </p>

            <ul className="space-y-5" data-id="element-153">
              {benefits.map((benefit, index) => <motion.li key={index} className="flex items-start gap-4" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.15
            }} data-id="element-154">
                  <CheckCircle2 className="w-6 h-6 text-brand-emerald flex-shrink-0 mt-0.5" data-id="element-155" />
                  <span className="text-lg font-medium text-brand-charcoal" data-id="element-156">
                    {benefit}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};